import { setTraitType, TraitType } from '@kp/traits/trait-type.enum';

export class UserTrait {
  constructor(public type?: TraitType, public traits?: string[]) {}

  deserialize(input: any): UserTrait {
    if (input == null) {
      return null;
    }
    this.type = setTraitType(input.type);
    this.traits = input.traits;
    return this;
  }
}
